import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import MQThreeAHGraph from "./MQThreeAHGraph";

class MQThreeAvailableHomes extends Component {
  componentDidMount() {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
  }
  render() {
    const {
      currentArea,
      quarterlyAreaTable,
      MQCityDetails,
      hoData,
      agentData,
      demoAccountAreaName,
      demoAccountCity,
      quarterlyCityTable,
      useCity,
      altVersion,
      printVersion,
      totalAreaActivesFromTable,
    } = this.props;

    const { mlsAreaID, mlsNeighborhood, mlsCityName } = currentArea;
    const { subdivisionName, coverPageHeader } = hoData;
    const { listgenUserID } = agentData;
    const { slashSeparatedArea, splitAreas, getSubdivisionName } = propertyUtil;

    let areaTitle = useCity
      ? mlsCityName
      : listgenUserID === "102935"
        ? "Our Neighborhood"
        : coverPageHeader === "Upper East and Lower Mission Canyon"
          ? "Upper East/Lower Mission Canyon"
          : coverPageHeader
            ? coverPageHeader
            : getSubdivisionName(subdivisionName, mlsNeighborhood);

    if (mlsAreaID === "SMA-390") {
      areaTitle = "Sea Colony Neighborhood";
    }
    let twoAreas = true;
    if (
      mlsAreaID === "157" ||
      mlsAreaID === "1522155" ||
      mlsAreaID === "SBA-45E" ||
      mlsAreaID === "NPA-E1200A"
    ) {
      twoAreas = false;
    }
    if (mlsCityName && quarterlyCityTable.monthsSupplyTable) {
      let cityName;
      let citySale;

      if (quarterlyCityTable && useCity) {
        const { monthsSupplyTable } = quarterlyCityTable;
        cityName = mlsCityName;
        citySale = monthsSupplyTable.CityNumberOfHousesForSale;
      } else {
        cityName = mlsCityName;
        citySale = MQCityDetails.numberOfHomesForSale;
      }
      let areaSale;

      if (useCity) {
        areaSale = citySale;
        // areaTitle = getSubdivisionName(
        //   subdivisionName,
        //   quarterlyCityTable.CityName
        // );
      } else {
        // areaSale =
        //   quarterlyAreaTable.monthsSupplyTable.AreaNumberOfHousesForSale;

        areaSale = quarterlyAreaTable.totalActiveListings;
      }

      const toSafeNumber = (value) => {
        const n = Number(value);
        return Number.isFinite(n) ? n : 0;
      };
      const clampPercentForArrow = (monthsSupply) =>
        Math.max(1, Math.min(100, Math.round(toSafeNumber(monthsSupply) * 10)));
      const monthSupplyToInventoryLabel = (monthsSupply) => {
        const n = toSafeNumber(monthsSupply);
        if (n < 4) return "Low";
        if (n <= 6) return "Balanced";
        return "High";
      };
      const formatOverflowDiff = (monthsSupply) => {
        const diff = toSafeNumber(monthsSupply) - 10;
        if (diff <= 0) return 0;
        return Math.round(diff);
      };

      const cityMonthsSupplyRaw =
        (quarterlyCityTable && useCity
          ? quarterlyCityTable.monthsSupplyTable?.CityMonthsSupply
          : undefined) ??
        MQCityDetails?.CityMonthsSupply ??
        MQCityDetails?.cityMonthsSupply ??
        quarterlyCityTable.monthsSupplyTable?.CityMonthsSupply ??
        0;
      const areaMonthsSupplyRaw =
        quarterlyAreaTable.monthsSupplyTable?.AreaMonthsSupply ?? 0;

      const cityPerc = clampPercentForArrow(cityMonthsSupplyRaw);
      const areaPerc = clampPercentForArrow(areaMonthsSupplyRaw);
      const cityInventory = monthSupplyToInventoryLabel(cityMonthsSupplyRaw);
      const areaInventory = monthSupplyToInventoryLabel(areaMonthsSupplyRaw);

      const cityOverflowDiff = formatOverflowDiff(cityMonthsSupplyRaw);
      const areaOverflowDiff = formatOverflowDiff(areaMonthsSupplyRaw);

      let allAreas;
      let areaSplit = splitAreas(mlsNeighborhood);
      const areaCount = areaSplit.length;
      allAreas = slashSeparatedArea(mlsNeighborhood);

      let availableHomesPositionStyles;

      let availableHomesColorStyles = "may-2025-available-homes-styles";
      // mlsAreaID.includes("ALA")
      //   ? "april-2025-available-homes-styles"
      //   : "feb-2025-available-homes-styles";
      if (
        cityName &&
        areaTitle &&
        mlsAreaID !== "NPA-E1200A" &&
        cityName.toLowerCase() === areaTitle.toLowerCase()
      ) {
        if (!cityName.toLowerCase().includes("city")) {
          cityName = `City of ${cityName}`;
        }

        if (!areaTitle.toLowerCase().includes("neighborhood")) {
          areaTitle = `${areaTitle} Neighborhood`;
        }
      }
      if (mlsAreaID === "ALA-2811D") {
        cityName = "City of Piedmont";
      }
      let showNeighborhoodGraph = true;
      if (
        mlsAreaID === "NPA-E0600C" ||
        mlsAreaID === "NPA-E0600A" ||
        mlsAreaID === "NPA-E0600B" ||
        mlsAreaID === "SBA-40G"
      ) {
        showNeighborhoodGraph = false;
        twoAreas = true;
      }
      const isCityOnlyGraph = twoAreas && !showNeighborhoodGraph;

      return (
        <div
          className={`${printVersion ? "print-" : "editor-"}${
            altVersion ? altVersion : "mq3"
          }-available-homes-container ${availableHomesPositionStyles} ${availableHomesColorStyles} ${
            isCityOnlyGraph ? "city-only-graph" : ""
          }`}
        >
          <div className="available-homes-inner">
            <div
              className={
                "ah-bar-container " +
                (!showNeighborhoodGraph
                  ? "two-areas"
                  : twoAreas
                    ? ""
                    : "two-areas")
              }
            >
              {twoAreas && (
                <MQThreeAHGraph
                  isCity={true}
                  areaCityName={cityName}
                  ddPerc={cityPerc}
                  inventory={cityInventory}
                  sale={citySale}
                  overflowDiff={cityOverflowDiff}
                  demoAccountCity={demoAccountCity}
                  currentArea={currentArea}
                />
              )}
              {showNeighborhoodGraph && (
                <MQThreeAHGraph
                  isCity={false}
                  areaCount={areaCount}
                  areaSplit={areaSplit}
                  demoAccountAreaName={demoAccountAreaName}
                  // areaCityName={allAreas}
                  areaCityName={areaTitle}
                  ddPerc={areaPerc}
                  inventory={areaInventory}
                  // mini table (miniTableDetailsDTO) is the source of truth when provided, even if 0.
                  // Other pages that don't pass it keep using totalActiveListings.
                  sale={
                    typeof totalAreaActivesFromTable === "number"
                      ? totalAreaActivesFromTable
                      : areaSale
                  }
                  overflowDiff={areaOverflowDiff}
                  twoAreas={twoAreas}
                  useCity={useCity}
                  currentArea={currentArea}
                />
              )}
            </div>
            <div className="inventory-bars-container">
              <div className="inventory-bar-item low-inventory-bar">
                <div className="sold inventory-legend" />
                <div className="bar-item-row">
                  <span>Low Inventory</span>
                  <span className="bar-item-divider"></span>
                  <span>&lt; 4 month's supply</span>
                </div>
              </div>

              <div className="inventory-bar-item">
                <div className="active inventory-legend" />
                <div className="bar-item-row">
                  <span>Balanced Inventory</span>
                  <span className="bar-item-divider"></span>
                  <span>4-6 month's supply</span>
                </div>
              </div>

              <div className="inventory-bar-item">
                <div className="primary inventory-legend" />
                <div className="bar-item-row">
                  <span>High Inventory</span>
                  <span className="bar-item-divider"></span>
                  <span>&gt; 6 month's supply</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <p>Loading..</p>;
    }
  }
}

export default MQThreeAvailableHomes;
